import { IS_PRODUCTION_ENVIRONMENT } from '@/constants';

const newRelicAgentPromise = IS_PRODUCTION_ENVIRONMENT
  ? import('@newrelic/browser-agent/loaders/browser-agent').then(
      (m: typeof import('@newrelic/browser-agent/loaders/browser-agent')): typeof m.BrowserAgent =>
        m.BrowserAgent,
    )
  : import('@/mocks/mockNewRelic').then(
      (m: typeof import('@/mocks/mockNewRelic')): typeof m.MockBrowserAgent => m.MockBrowserAgent,
    );

export type NewRelicAgentClass = Awaited<typeof newRelicAgentPromise>;

export default newRelicAgentPromise;
